import React from 'react'
import { Grid, Button } from 'semantic-ui-react';
import { dispatch } from '@rematch/core';
import { Form } from 'formsy-semantic-ui-react';
import { toastr } from 'react-redux-toastr';
import { source } from 'react-aim';
import EllipsisTooltip from '../../../../common/EllipsisTooltip';
import _ from 'lodash';
let propName = '';
let propValue = '';
let optionsArray = [];

@source({
    mouseEnter: (props, component) => {
        dispatch.app.setHelpContext(props.nameOfHelpText)
    }
})
class PracticeFlowResourcePaneForm extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            option: 'raci',
            isDisabled: true
        }
        this.deleteA = this.deleteA.bind(this);
        this.deleteR = this.deleteR.bind(this);
        this.deleteC = this.deleteC.bind(this);
        this.deleteI = this.deleteI.bind(this);
        this.createRaciObject = this.createRaciObject.bind(this);
    }
    componentWillMount() {
        this.createOptionsArray();
    }
    createOptionsArray() {
        optionsArray = [];
        if (this.props.communityOptions) {
            this.props.communityOptions.map((community) => {
                if (community.communities) {
                    community.communities.map((subCommunity) => {
                        if (this.props.selectedPracticeFlowActivity && !this.props.selectedPracticeFlowActivity.raci ||
                            (propName === 'a' && this.props.selectedPracticeFlowActivity.raci.a !== subCommunity._id) ||
                            ((propName === 'r' && (!this.props.selectedPracticeFlowActivity.raci.r || this.props.selectedPracticeFlowActivity.raci.r.indexOf(subCommunity._id) === -1)) ||
                                (propName === 'c' && (!this.props.selectedPracticeFlowActivity.raci.c || this.props.selectedPracticeFlowActivity.raci.c.indexOf(subCommunity._id) === -1)) ||
                                (propName === 'i' && (!this.props.selectedPracticeFlowActivity.raci.i || this.props.selectedPracticeFlowActivity.raci.i.indexOf(subCommunity._id) === -1)) ||
                                (propName === 'r+a' && this.props.selectedPracticeFlowActivity.raci && ((this.props.selectedPracticeFlowActivity.raci.a && this.props.selectedPracticeFlowActivity.raci.a && this.props.selectedPracticeFlowActivity.raci.a !== subCommunity._id) || !this.props.selectedPracticeFlowActivity.raci.a) && (!this.props.selectedPracticeFlowActivity.raci.r || this.props.selectedPracticeFlowActivity.raci.r.findIndex(x => x == subCommunity._id) === -1)))
                        ) {
                            optionsArray.push({ id: subCommunity._id, label: community.name + " > " + subCommunity.name });
                        }

                    }, this)
                }

            }, this);
        }
    }
    componentWillReceiveProps(nextProps) {
        if (!_.isEqual(this.props, nextProps)) {
            this.setState({ option: 'raci' });
            optionsArray = [];
        }
    }
    createRaciObject(data) {
        switch (data.target.name) {
            case 'raci': propName = data.target.value ? data.target.value : '';
                this.setState({ option: data.target.value });
                this.createOptionsArray();
                break;
            case 'assignment': propValue = data.target.value ? data.target.value : '';
        }
        if (propName && propValue) {
            this.setState({ isDisabled: false })
        }
    }
    resetDropDown() {
        this.setState({ option: 'raci' })
    }
    addRaciToActivity(formData, resetForm) {

        if ((propName === 'r' || propName === 'a' || propName === 'c' || propName === 'i' || propName === 'r+a') && (propValue && propValue !== 'Select')) {
            if (!this.props.selectedPracticeFlowActivity.raci) {
                this.props.selectedPracticeFlowActivity.raci = {};
            }
            if (propName === 'a') {
                if (this.props.selectedPracticeFlowActivity.raci[propName]) {
                    this.deleteFromActivityActions(propName, this.props.selectedPracticeFlowActivity.raci[propName]);
                }
                this.props.selectedPracticeFlowActivity.raci[propName] = propValue;
            }
            else if (propName === 'r+a') {
                if (this.props.selectedPracticeFlowActivity.raci.a) {
                    this.deleteFromActivityActions("a", this.props.selectedPracticeFlowActivity.raci.a);
                }
                this.props.selectedPracticeFlowActivity.raci.a = propValue;
                if (!this.props.selectedPracticeFlowActivity.raci.r)
                    this.props.selectedPracticeFlowActivity.raci.r = [];
                this.props.selectedPracticeFlowActivity.raci.r.push(propValue);
            }
            else {
                if (!this.props.selectedPracticeFlowActivity.raci[propName])
                    this.props.selectedPracticeFlowActivity.raci[propName] = [];
                this.props.selectedPracticeFlowActivity.raci[propName].push(propValue);
            }
            dispatch.createPack.setRACIObject(this.props.selectedPracticeFlowActivity.raci);
            let actionObject = {};
            if (propName === 'r+a') {
                actionObject.r = propValue;
                actionObject.a = propValue;
            }
            else {
                actionObject[propName] = propValue;
            }

            dispatch.createPack.updateActivityAction(actionObject);
            this.props.editActivity();
            optionsArray = [];
            propName = '';
            propValue = '';
            this.setState({ isDisabled: true });
        }
        else {
            toastr.error('Message', 'Please select options from dropdown.');
        }
        this.resetDropDown();
    }
    getMapping(id) {
        if (this.props.communityOptions)
            for (let i = 0; i < this.props.communityOptions.length; i++) {
                let community = this.props.communityOptions[i];
                if (id === community._id) {
                    return community.name;
                }
                if (community.communities) {
                    for (let j = 0; j < community.communities.length; j++) {
                        let subCommunity = community.communities[j];
                        if (id === subCommunity._id) {
                            return community.name + " > " + subCommunity.name;
                        }
                    }
                }

            }
    }
    deleteFromActivityActions(propertyName, id) {
        let indexInActions = (() => {
            for (let i = 0; i < this.props.activityActions.length; i++) {
                if (this.props.activityActions[i][propertyName] && this.props.activityActions[i][propertyName] === id && !this.props.activityActions[i].deleted) {
                    return i;
                }
            }
            return -1;
        })();
        if (indexInActions !== -1) {
            dispatch.createPack.removeFromActivityAction(indexInActions);
        } else {

            let actionObject = {};
            actionObject[propertyName] = id;
            actionObject.deleted = true;
            dispatch.createPack.updateActivityAction(actionObject);
        }
    }
    deleteA() {
        let id = this.props.selectedPracticeFlowActivity.raci.a;
        let message = <div className="confirmMessage">
            <h3>Delete Role</h3>
            <p>Are you sure that you wish to delete this role?</p>
            <span >This action is not reversible</span>
        </div>
        toastr.confirm(message, {
            onOk: () => {
                delete this.props.selectedPracticeFlowActivity.raci.a;
                dispatch.createPack.setRACIObject(this.props.selectedPracticeFlowActivity.raci);
                this.deleteFromActivityActions('a', id);
                this.props.editActivity();
            }
        });
    }
    deleteR(id) {
        let index = this.props.selectedPracticeFlowActivity.raci.r.indexOf(id);
        let message = <div className="confirmMessage">
            <h3>Delete role</h3>
            <p>Are you sure that you wish to delete this role?</p>
            <span >This action is not reversible</span>
        </div>
        toastr.confirm(message, {
            onOk: () => {
                if (index != -1) {
                    this.deleteFromActivityActions('r', id);
                    this.props.selectedPracticeFlowActivity.raci.r.splice(index, 1)
                    this.props.editActivity();
                }
            }
        });
    }
    deleteC(id) {
        let index = this.props.selectedPracticeFlowActivity.raci.c.indexOf(id);
        let message = <div className="confirmMessage">
            <h3>Delete Role</h3>
            <p>Are you sure that you wish to delete this role?</p>
            <span >This action is not reversible</span>
        </div>
        toastr.confirm(message, {
            onOk: () => {
                if (index !== -1) {
                    this.deleteFromActivityActions('c', id);
                    this.props.selectedPracticeFlowActivity.raci.c.splice(index, 1)
                    this.props.editActivity();
                }
            }
        });
    }
    deleteI(id) {
        let index = this.props.selectedPracticeFlowActivity.raci.i.indexOf(id);
        let message = <div className="confirmMessage">
            <h3>Delete Role</h3>
            <p>Are you sure that you wish to delete this role?</p>
            <span >This action is not reversible</span>
        </div>
        toastr.confirm(message, {
            onOk: () => {
                if (index !== -1) {
                    this.deleteFromActivityActions('i', id);
                    this.props.selectedPracticeFlowActivity.raci.i.splice(index, 1)
                    this.props.editActivity();
                }
            }
        });
    }
    resetForm() {
        document.getElementById("raciForm").reset();
    }
    render() {
        const showDeleteA = () => {
            if (this.props.status === 0) {
                return (
                    <Grid.Column width={2}>
                        <Button icon="trash alternate" className="trash-color" style={{ 'background': 'white', 'padding': '5px', 'margin-top': '4px' }} onClick={this.deleteA}></Button>
                    </Grid.Column>
                )
            }
        }
        const showA = () => {
            if (this.props.selectedPracticeFlowActivity.raci && this.props.selectedPracticeFlowActivity.raci.a) {
                return (
                    <Grid.Row >
                        <Grid.Column width={4}>
                            <div className="divBlock">
                                <EllipsisTooltip name="Accountable" /></div>
                        </Grid.Column>
                        <Grid.Column width={10}>
                            <div className="divBlock">
                                <EllipsisTooltip
                                    name={this.getMapping(this.props.selectedPracticeFlowActivity.raci.a)}
                                />
                            </div>
                        </Grid.Column>
                        {showDeleteA()}
                    </Grid.Row>
                )
            }
        }
        const showForm = () => {
            if (this.props.status === 0) {
                return (
                    <Form noValidate
                        name='raciForm'
                        className="formcyForm pad_0 "
                        id='raciForm'
                        ref={ref => this.form = ref}
                        onValidSubmit={(formData) => { this.addRaciToActivity(formData) }}
                    >
                        <Grid.Row width={16}>
                            <Form.Group inline >
                                <Grid.Column width={4} >

                                    <Form.Field
                                        placeholder="RACI"
                                        name='raci'
                                        id='raci'
                                        required
                                        onChange={this.createRaciObject}
                                        control='select'
                                        style={{ 'width': '100%' }}
                                        value={this.state.option}
                                    >

                                        <option value='raci'>RACI</option>
                                        <option value='r+a'>Responsible + Accountable</option>
                                        <option value='r'>Responsible</option>
                                        <option value='a'>Accountable</option>
                                        <option value='c'>Consulted</option>
                                        <option value='i'>Informed</option>
                                    </Form.Field>

                                </Grid.Column>
                                <Grid.Column width={10}>

                                    <Form.Field
                                        control='select'
                                        onChange={this.createRaciObject}
                                        name='assignment'
                                        id='assignment'>
                                        <option>Select</option>
                                        {optionsArray && optionsArray.map((community) => {

                                            return <option value={community.id} key={community.id}>{community.label}</option>

                                        })}
                                    </Form.Field>

                                </Grid.Column>
                                <Grid.Column style={{marginTop: "-10px"}} width={2}>
                                    <Button size="mini" icon="plus" type="submit" id="submit" disabled={this.state.isDisabled}></Button>
                                </Grid.Column>
                            </Form.Group>
                        </Grid.Row>
                    </Form>
                )
            }

        }
        let deleteButton = (deleteAction, id) => {
            if (this.props.status === 0) {
                return (
                    <Grid.Column width={2}>
                        <Button icon="trash alternate" className="trash-color" style={{ 'background': 'white', 'padding': '5px', 'margin-top': '4px' }} onClick={() => deleteAction(id)}></Button>
                    </Grid.Column>
                )
            }
        }
        return (
            <Grid  >
                {showForm()}

                {showA()}
                {this.props.selectedPracticeFlowActivity.raci && this.props.selectedPracticeFlowActivity.raci.r &&
                    this.props.selectedPracticeFlowActivity.raci.r.map((r) => {
                        return (
                            <Grid.Row key={r}>
                                <Grid.Column width={4}>
                                    <div className="divBlock">
                                        <EllipsisTooltip name="Responsible" />
                                    </div>
                                </Grid.Column>
                                <Grid.Column width={10}>
                                    <div className="divBlock">
                                        <EllipsisTooltip
                                            name={this.getMapping(r)}
                                        />
                                    </div>
                                </Grid.Column>
                                {deleteButton(this.deleteR, r)}
                            </Grid.Row>
                        )

                    })
                }
                {this.props.selectedPracticeFlowActivity.raci && this.props.selectedPracticeFlowActivity.raci.c &&
                    this.props.selectedPracticeFlowActivity.raci.c.map((c) => {
                        return (
                            <Grid.Row key={c}>
                                <Grid.Column width={4}>
                                    <div className="divBlock">
                                        <EllipsisTooltip name="Consulted" />
                                    </div>
                                </Grid.Column>
                                <Grid.Column width={10}>
                                    <div className="divBlock">
                                        <EllipsisTooltip
                                            name={this.getMapping(c)}
                                        />
                                    </div>
                                </Grid.Column>
                                {deleteButton(this.deleteC, c)}
                            </Grid.Row>
                        )

                    })
                }
                {this.props.selectedPracticeFlowActivity.raci && this.props.selectedPracticeFlowActivity.raci.i &&
                    this.props.selectedPracticeFlowActivity.raci.i.map((i) => {
                        return (
                            <Grid.Row key={i}>
                                <Grid.Column width={4}>
                                    <div className="divBlock">
                                        <EllipsisTooltip name="Informed" />
                                    </div>
                                </Grid.Column>
                                <Grid.Column width={10}>
                                    <div className="divBlock">
                                        <EllipsisTooltip
                                            name={this.getMapping(i)}
                                        />
                                    </div>
                                </Grid.Column>
                                {deleteButton(this.deleteI, i)}
                            </Grid.Row>
                        )

                    })
                }
            </Grid>
        )
    }
}
export default PracticeFlowResourcePaneForm